console.log('ACTIVIS - App.js loadé');

import './_header';